import { useEffect, useState } from "react";
import { Pokemon } from "../types/Pokemon";

export const GetPokemons = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [pokemons, setPokemons] = useState<Pokemon[]>([]);

  const getPokemons = async () => {
    setIsLoading(true);
    const response = await fetch("https://pokeapi.co/api/v2/pokemon?limit=493");
    const data = await response.json();
    const pokemons = await Promise.all(
      data.results.map(async (pokemon: Pokemon) => {
        const response = await fetch(pokemon.url);
        const data = await response.json();
        return data;
      }),
    );
    setPokemons(pokemons);
    setIsLoading(false);
  };

  useEffect(() => {
    getPokemons();
  }, []);

  return {
    isLoading,
    setIsLoading,
    pokemons,
  };
};
